import { Helmet } from "react-helmet-async";

export default function SEOHead({ title, description, image, type = "article", url, articleId }) {
  const siteName = "Pulse Medical Media";
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const desc = description || "Trusted Medical News & Awareness Platform - Evidence-based healthcare content for readers worldwide.";
  const ogImage = image || (articleId ? `${process.env.REACT_APP_BACKEND_URL}/api/og-image/${articleId}` : null);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
